import type { ZudokuConfig } from "zudoku";

export const metadata: ZudokuConfig["metadata"] = {
	title: "Beam Developer Portal",
	favicon: "/favicon.png",
};
